import React from 'react'
import { Meta } from '../../../components'
import { renderMeta } from '../../../utils'

const CardInfoMobile = ({data, isOpen}) => {
  const {
    type,
    // since,
    approach,
    location,
    // issues
  } = data

  return (
    <div className="flex flex-wrap justify-between w-full">
      <div className="w-1/2 lg:w-1/4">
        <Meta
          className="mb-3 lg:mb-2 pr-2 lg:pr-0"
          label="Type"
          value={renderMeta('type',type)}
        />
        {/* <Meta
          className="mb-3 lg:mb-2 pr-2 lg:pr-0"
          label="Established Since"
          value={since}
        /> */}
      </div>
      <div className="w-1/2 lg:w-1/4">
        <Meta
          className="mb-3 lg:mb-2 pr-2 lg:pr-0"
          label="Approach"
          value={renderMeta('approach',approach)}
        />
      </div>

      {
        isOpen &&
        <React.Fragment>
          <div className="w-1/2 lg:w-1/4">
            <Meta
              className="mb-3 lg:mb-2 pr-2 lg:pr-0"
              label="Location"
              value={location}
            />
          </div>
          {/* <div className="w-1/2 lg:w-1/4">
            <Meta
              className="mb-3 lg:mb-2 pr-2 lg:pr-0"
              label="Issues"
              value={issues}
            />
          </div> */}
        </React.Fragment>
      }
    </div>
  )
}

export { CardInfoMobile }
